interface TabProps {
  onModeSwitch?: () => void;
  isJiraActive: boolean;
  disabled?: boolean;
}

export default function Tabs({
  onModeSwitch,
  isJiraActive = false,
  disabled = false,
}: TabProps) {
  const activeClass =
    'rounded-md bg-white px-3 py-0.5 text-xs font-bold text-primary-700 shadow-sm cursor-default';
  const inactiveClass =
    'rounded-md px-3 py-0.5 text-xs font-medium text-gray-500 hover:text-gray-900 hover:bg-gray-200 cursor-pointer transition-colors';

  return (
    <div className="flex items-center justify-between pr-4">
      <div
        className={`flex items-center gap-1 rounded-lg bg-gray-100 p-1 ${disabled ? 'pointer-events-none opacity-50' : ''}`}
      >
        <button
          onClick={!disabled && isJiraActive ? onModeSwitch : undefined}
          className={!isJiraActive ? activeClass : inactiveClass}
          disabled={!isJiraActive || disabled}
        >
          Aha!
        </button>
        <button
          onClick={!disabled && !isJiraActive ? onModeSwitch : undefined}
          className={isJiraActive ? activeClass : inactiveClass}
          disabled={isJiraActive || disabled}
        >
          Jira
        </button>
      </div>
    </div>
  );
}
